export const assetDealsFields = ["id", "name", "offer_received", "asking_price", "asking_price_type"]